export default {"src":"/_next/static/media/samsung_logo.345ff913.svg","height":42,"width":108,"blurWidth":0,"blurHeight":0};